(function(){
    angular
        .module('appback')
        .filter('trustUrl', trustUrl);

        trustUrl.$inject = ['$sce'];
        function trustUrl($sce){
            return function (recordingUrl) {
	            return $sce.trustAsResourceUrl(recordingUrl);
	        };
      }
})();